export enum OnboardingStatus {
  NotStarted = 1,
  InProgress = 2,
  Done = 3,
}

export interface OnboardingStep {
  stepKey: string;
  status: OnboardingStatus;
}

export interface OnboardingCategory {
  categoryKey: string;
  steps: OnboardingStep[];
}

export interface OnboardingState {
  targetId: string;
  targetType: string;
  companyBadgeCount: number;
  projectsBadgeCount: number;
  categories: OnboardingCategory[];
}
